import { Swiper } from './swiper-dK1UiadY.js';
import { P as Pagination } from './pagination-BK2B-KDe.js';
import { A as A11y } from './a11y-DLppOU3x.js';
import './utils-Djv5ZeLF.js';

class USPSSection extends HTMLElement {
  #swiper = this;
  #pagination = this.querySelector('.swiper-pagination');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: this.#pagination,
        type: 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('usps-section', USPSSection);
